import { render, staticRenderFns } from "./AgendasConsultorio.vue?vue&type=template&id=d8a72088&"
import script from "./AgendasConsultorio.vue?vue&type=script&lang=js&"
export * from "./AgendasConsultorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports